/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandBandcamp = createReactComponent("brand-bandcamp", "IconBrandBandcamp", [
  ["path", { d: "M8.5 6h13.5l-7 12h-13z", key: "svg-0" }]
]);

export { IconBrandBandcamp as default };
//# sourceMappingURL=IconBrandBandcamp.js.map
